<div class="success-lightbox" [style.display]="showSuccess ? 'flex' : 'none'">
  <div class="success-lightbox__content">
    <p>Thank you for your sample-order.<br> We will process your order as soon as possible</p>
    <button class="success-lightbox__close" (click)="closeDialog()">Ok</button>
  </div>
</div>

<div class="lightbox" [style.display]="showSuccess ? 'none' : 'flex'">
  <div class="lightbox--content">
    <div class="lightbox--header" i18n="@order_header">
      Your DRIVOSOL® sample
    </div>

    <div class="lightbox--disclaimer" i18n="@order_disclaimer">
      <strong>Please note that we can only provide samples for you if you are based in Europe.</strong>
      Furthermore, our minimum order quantity for possible deliveries of DRIVOSOL® is 10 mt. Please only ask for samples if both is the case.<br>
      All samples will be delivered in 1 litre monobloc cans.
    </div>

    <form class="sample-order__form form--mixing" [formGroup]="form" (ngSubmit)="send()">
      <h3 class="text--uppercase" i18n="@order_your_free_sample_order">Your free sample order</h3>
      <div class="label-box" i18n="@order_your_mixture">Your DRIVOSOL® mixture:</div>

      <table>
        <thead>
          <tr>
            <th i18n="@order_product_name">Product name</th>
            <th i18n="@order_propane">Propane</th>
            <th i18n="@order_isobutane">iso-Butane</th>
            <th i18n="@order_butane">n-Butane</th>
            <th i18n="@order_pressure">Pressure in bar (20°C)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><input name="product_name" formControlName="product_name" readonly id="lightbox-name" class="milky" type="text"></td>
            <td><input name="propane" formControlName="propane" readonly id="lightbox-propane" class="milky" type="text"></td>
            <td><input name="isobutane" formControlName="isobutane" readonly id="lightbox-isobutane" class="milky" type="text"></td>
            <td><input name="butane" formControlName="butane" readonly id="lightbox-butane" class="milky" type="text"></td>
            <td><input name="bar" formControlName="bar" readonly id="lightbox-bar" class="milky" type="text"></td>
          </tr>
        </tbody>
      </table>

      @if (hasError()) {
        <div class="form-message error-message" i18n="@order_error">Please check the red marked fields, these must be filled in correctly.</div>
      }

      <label class="label--top label--required" for="sample_usecase" i18n="@order_sample_usecase">For which application will our DRIVOSOL® be used?</label>
      <input type="text" name="sample_usecase" id="sample_usecase" formControlName="sample_usecase" [class.invalid]="hasFieldError('sample_usecase')">
      <label class="label--top  label--required" for="annual_demand" i18n="@order_annual_demand">Your annual demand in mt:</label>
      <input type="text" name="annual_demand" id="annual_demand" formControlName="annual_demand" [class.invalid]="hasFieldError('annual_demand')">
      <div class="form__section section-02">
        <h3 i18n="@order_ship_to_address">Ship to Address</h3>
      </div>
      <div class="form__field">
        <label class="label--required" for="company" i18n="@order_company">Company</label>
        <input name="company" type="text" id="company" formControlName="company" [class.invalid]="hasFieldError('company')">
      </div>
      <div class="form__field">
        <label class="label--required" for="department" i18n="@order_department">Department</label>
        <input name="department" type="text" id="department" formControlName="department" [class.invalid]="hasFieldError('department')">
      </div>
      <div class="form__field">
        <label class="label--required" for="street" i18n="@order_street">Street & House No.</label>
        <input name="street" type="text" id="street" formControlName="street" [class.invalid]="hasFieldError('street')">
      </div>
      <div class="form__field">
        <label for="additional" i18n="@order_additional">Additional address details if needed</label>
        <input name="additional" type="text" id="additional" formControlName="additional">
      </div>
      <div class="form__field">
        <label class="label--required" for="zipcode" i18n="@order_zipcode">Postal Code</label>
        <input name="zipcode" type="text" id="zipcode" formControlName="zipcode" [class.invalid]="hasFieldError('zipcode')">
      </div>
      <div class="form__field">
        <label class="label--required" for="city" i18n="@order_city">City</label>
        <input name="city" type="text" id="city" formControlName="city" [class.invalid]="hasFieldError('city')">
      </div>
      <div class="form__field">
        <label class="label--required" for="country" i18n="@order_country">Country</label>
        <select name="country" id="country" formControlName="country" [class.invalid]="hasFieldError('country')">
          <option value="" i18n="@order_select_country">Select Country</option>
          @for (country of countries; track country) {
            <option [value]="country.value">{{ country.label }}</option>
          }
        </select>
      </div>
      <div class="form__field">
        <label class="label--required" for="contact" i18n="@order_contact">Responsible contact Person</label>
        <input name="contact" type="text" id="contact" formControlName="contact" [class.invalid]="hasFieldError('contact')">
      </div>
      <div class="form__field">
        <label class="label--required" for="phone" i18n="@order_phone">Phone No.</label>
        <input name="phone" type="text" id="phone" formControlName="phone" [class.invalid]="hasFieldError('phone')">
      </div>
      <div class="form__field mb-40">
        <label class="label--required" for="email" i18n="@order_email" [class.invalid]="true">Email address</label>
        <input name="email" type="text" id="email" formControlName="email" [class.invalid]="hasFieldError('email')">
      </div>
      <label class="label--top" for="further" i18n="@order_further">Here you may add further wishes/remarks:</label>

      <textarea name="further" id="further" cols="30" rows="3" formControlName="further"></textarea>
      <button type="submit" i18n="@order_send">Send</button>
    </form>
  </div>

</div>
